

export const COGNITO_AUTH_ENDPOINT = (state: string) => {
  const cognitoClientId = process.env.REACT_APP_COGNITO_CLIENT_ID || ''
  const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN_NAME || ''
  const redirectUrl = process.env.REACT_APP_COGNITO_REDIRECT_URL || ''
  const identityProvider = process.env.REACT_APP_COGNITO_IDENTITY_PROVIDER || ''
  return `https://${cognitoDomain}.auth.us-east-1.amazoncognito.com/oauth2/authorize?response_type=code&client_id=${cognitoClientId}&redirect_uri=${redirectUrl}&state=${encodeURIComponent(
    state
  )}&identity_provider=${identityProvider}`
}

export const COGNITO_TOKEN_ENDPOINT = (
  cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN_NAME || ''
) => {
  return `https://${cognitoDomain}.auth.us-east-1.amazoncognito.com/oauth2/token`
}

export const COGNITO_USER_INFO_ENDPOINT = (
  cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN_NAME || ''
) => {
  return `https://${cognitoDomain}.auth.us-east-1.amazoncognito.com/oauth2/userInfo`
}

export const CREATE_EVENT = () => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events`
}

export const EDIT_EVENT = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}`
}

export const CANCEL_EVENT = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/cancel`
}

export const DELETE_EVENT = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/delete`
}

export const GET_ALL_EVENTS = () => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events`
}

export const GET_ALL_USER_EVENTS = (userEmail: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}${userEmail}/events`
}

export const GET_ATTENDESS = (eventId: string) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }/events/${eventId}/attendees`
}

export const GET_EVENT = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}`
}

export const GET_EVENT_METRICS = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/metrics`
}

export const GET_EVENT_IMAGES = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/images`
}

export const POST_EVENT_IMAGE = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/images`
}

export const GET_USERS_EMAILS = () => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}users`
}

export const TRACK_VISIT = () => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}users/track-visit`
}

export const GET_EVENT_IMAGE_BASE_64 = (eventId: string, imageName: string) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }/events/${eventId}/images/${imageName}/base64`
}

export const GET_EVENT_SIGNUPS = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/sign-ups`
}

export const GET_EVENT_SIGNUP_FOR_USER = (
  eventId: string,
  participantEmail: string
) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }events/${eventId}/sign-up/${participantEmail}`
}

export const JOIN_EVENT = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}/events/${eventId}/join`
}

export const JOIN_EVENT_MANUALLY = (eventId: string) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }/events/${eventId}/join-manual`
}

export const SEARCH_EVENTS = (
  term: string,
  status: 'ACTIVE' | 'COMPLETE' | 'ALL'
) => {
  const params = new URLSearchParams({ term, status })
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }events/search?${params.toString()}`
}

export const SIGNUP_USER_TO_EVENT = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/sign-up`
}

export const UNSIGNUP_USER_TO_EVENT = (eventId: string) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }events/${eventId}/unsign-up`
}

export const GET_AVAILABLE_ROOMS = (
  office: string,
  eventStartDateTime: number,
  eventEndDateTime: number
) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }offices/${office}/rooms/available?eventStartDateTime=${eventStartDateTime}&eventEndDateTime=${eventEndDateTime}`
}

export const TRIGGER_EVENT_EMAIL_ACTION = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/email`
}

export const POST_PHOTO_REACTION = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}photo-reactions/${eventId}`
}

export const GET_PHOTO_REACTIONS = (eventId: string, imageKey: string) => {
  const params = new URLSearchParams({ imageKey })
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }/photo-reactions/${eventId}?${params.toString()}`
}

export const SUBMIT_EVENT_FEEDBACK = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/feedback`
}

export const CHECK_FEEDBACK_GIVEN = (eventId: string, userId: string) => {
  return `${
    process.env.REACT_APP_API_BASE_URL || ''
  }events/${eventId}/attendees/${userId}`
}

export const GET_EVENT_FEEDBACK_METRICS = (eventId: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/metrics`
}

export const APPSYNC_ENDPOINT = () => {
  return `${process.env.REACT_APP_APPSYNC_API_ENDPOINT || ''}`
}

export const GET_MATCHMAKER_IMAGES_ENDPOINT = (eventId: string, uploaderEmail: string) => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}events/${eventId}/images/matchmaker/${uploaderEmail}`
}

export const GET_FEATURES = () => {
  return `${process.env.REACT_APP_API_BASE_URL || ''}features`
}

export const GET_ANALYTICS = (startDate: string, endDate: string, eventFormats: string[], eventTags: string[], selectedEventTypes: string[], selectedLocations: string[] ) => {
  const params = new URLSearchParams({startDate, endDate, format: eventFormats.toString(), tags: eventTags.toString(), type: selectedEventTypes.toString(), location: selectedLocations.toString() })
  return `${process.env.REACT_APP_API_BASE_URL || ''}analytics/filtered-events?${params.toString()}`
}
